import React, { useEffect } from "react";
import Container from "../Partials/ProgressBar";
import { useLocation } from "react-router";
import { createBrowserHistory } from "history";
import logo from "../../images/hrlogo_new.png";

const queryString = require("query-string");
const history = createBrowserHistory();

export default function UrlSignIn(props) {
  const location = useLocation();
  const queryToken = queryString.parse(location.search).token;

  useEffect(() => {
    props.login(queryToken);
  }, []);

  useEffect(() => {
    if (props.user) {
      redirectSuccessLogin();
    }
  }, [props.user]);

  const redirectSuccessLogin = () => {
    history.push(`/`);
    window.location.reload();
  };

  return (
    <>
      {props.loading ? (
        <Container redirect={true} />
      ) : props.user ? (
        <div className="App">
          <h1 className="">Redirecting...</h1>
        </div>
      ) : (
        <>
          {!props.loginError ? (
            <Container redirect={true} />
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                backgroundColor: "#222831",
                padding: "20px",
                textAlign: "center",
              }}
            >
              <img
                src={logo}
                alt="Hudson Rock Logo"
                style={{
                  maxWidth: "400px",
                  width: "100%",
                  marginBottom: "40px",
                }}
              />
              <h1
                style={{
                  color: "#fecc4c",
                  fontSize: "32px",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Access Denied
              </h1>
              <p
                style={{
                  color: "#ffffff",
                  fontSize: "18px",
                  maxWidth: "600px",
                  lineHeight: "1.6",
                  marginBottom: "30px",
                }}
              >
                Your account may be inactive or this access link may have
                expired.
                <br />
                Please contact our support team for assistance.
              </p>
              <span
                style={{
                  color: "#fecc4c",
                  fontSize: "20px",
                  fontWeight: "600",
                  textDecoration: "none",
                }}
              >
                support@hudsonrock.com
              </span>
            </div>
          )}
        </>
      )}
    </>
  );
}
